import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import { IOperateLog, pageOperateLogs } from '../../service/api/account';
import { FormInstance } from 'antd/lib/form/Form';
import moment from 'moment';
const { confirm } = Modal;
const { Option } = Select;

interface IOperateLogListProps {
  visible: boolean
  setVisible: (visible: boolean) => void;
}
const OperateLogList: React.FC<IOperateLogListProps> = ({
  visible,
  setVisible,
}) => {
  const [operateLogs, setOperateLogs] = useState<IOperateLog[]>();
  const [pageNum, setPageNum] = useState(1);
  const [pageTotal, setPageTotal] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const formRef = React.createRef<FormInstance>();
  const columns = [
    {
      title: '操作名称',
      width: 180,
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '请求地址',
      width: 180,
      dataIndex: 'url',
      key: 'url',
    },
    {
      title: '操作人',
      width: 100,
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
    {
      title: '操作时间',
      width: 180,
      dataIndex: 'creationTime',
      key: 'creationTime',
      render(val: Date) {
        return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : <>&mdash;</>
      },
    },
    {
      title: '请求参数',
      dataIndex: 'request',
      key: 'request',
    },
    {
      title: '返回结果',
      dataIndex: 'response',
      key: 'response',
    },
    {
      title: '耗时（ms）',
      width: 120,
      dataIndex: 'costTime',
      key: 'costTime',
    },
    // {
    //   title: '状态',
    //   dataIndex: 'enable',
    //   key: 'enable',
    //   render: (text: any, record: any) => {
    //     if (record.enable) {
    //       return <span style={{color:'green'}}>使用中</span>
    //     } else {
    //       return <span style={{color:'grey'}}>已停用</span>
    //     }
    //   }
    // },
    // {
    //   title: '操作',
    //   key: 'action',
    //   // render: (text: any, record: any) => {
    //   //   if (record.enable) {
    //   //     return <Space size="middle">
    //   //       <a onClick={() => {
    //   //         // console.log("record:" + JSON.stringify(record));
    //   //         setOperateLogDetail(record);
    //   //         setVisible(true);
    //   //       }}>编辑 </a>
    //   //       <a onClick={e => { onEnable(e, record) }}>停用 </a>
    //   //     </Space>
    //   //   } else {
    //   //     return <Space size="middle">
    //   //       <a onClick={() => {
    //   //         // console.log("record:" + JSON.stringify(record));
    //   //         setOperateLogDetail(record);
    //   //         setVisible(true);
    //   //       }}>编辑 </a>
    //   //       <a onClick={e => { onEnable(e, record) }}>启用 </a>
    //   //     </Space>
    //   //   }
    //   // },
    // }
  ];

  useEffect(() => {
    loadData();
  }, [pageNum, pageSize]);

  const loadData = () => {
    pageOperateLogs(pageNum, pageSize).then((info: any) => {
      setOperateLogs(info?.data.list);
      setPageTotal(info?.data.total);
      // console.log("info:" + JSON.stringify(info.data));
    });
  }

  // const onFinish = (values: any) => {
  //   // console.log("values:" + JSON.stringify(values));
  //   if (operateLogDetail) {
  //     updateOperateLog({
  //       ...values,
  //       id: operateLogDetail.id
  //     }).then((info: any) => {
  //       // console.log("info:" + JSON.stringify(info));
  //       message.success("更新成功");
  //       onClose();
  //       loadData();
  //     });
  //   } else {
  //     createOperateLog(values).then((info: any) => {
  //       // console.log("info:" + JSON.stringify(info));
  //       message.success("创建成功");
  //       onClose();
  //       loadData();
  //     });
  //   }
  // };

  // const onEnable = (e: any, item: IRoleOperateLog) => {
  //   e.stopPropagation();
  //   confirm({
  //     title: '提示',
  //     icon: <ExclamationCircleOutlined />,
  //     content: item.enable?'确定要停用该权限吗？停用后无法被选到':'确定要启用该权限吗？',
  //     okText: '确定',
  //     okType: 'danger',
  //     cancelText: '取消',
  //     onOk() {
  //       enableOperateLog(item.id, !item.enable).then((info: any) => {
  //         // console.log("info:" + JSON.stringify(info));
  //         message.success("操作成功");
  //         loadData();
  //       });
  //     },
  //     onCancel() {
  //     },
  //   });
  // }

  const onPageChange = (pageNum: number, pageSize?: number) => {
    setPageNum(pageNum);
    setPageSize(pageSize || 10);
    // setPageSize(info.data.pageSize);
  }

  return (
    <Card bordered={false}>
      <Table dataSource={operateLogs} columns={columns} scroll={{ x: 'true' }} pagination={false} />
      <div style={{ display: "flex", justifyContent: "flex-end", paddingTop: "10px" }}>
      <Pagination
          defaultCurrent={pageNum}
          total={pageTotal}
          pageSize={pageSize}
          hideOnSinglePage={false}
          className="pagination"
          onChange={onPageChange}
          showSizeChanger
          showTotal={total => `共计 ${total} 条`}
        />
      </div>
    </Card>
  );
};

export default OperateLogList;
